import React, { useContext, useState } from "react";
import "./accountContact.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import generalRequest from "../../../request/generalRequest";
import BannerMessageFixed from "../../common/bannerMessageFixed/bannerMessageFixed";

const AccountContact = () => {
    const { language, userData } = useContext(CombinedContext);

    const [form, setForm] = useState({
        email: userData?.user?.email || "",
        phone: "",
        subject: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.message) {
            setError(translations[language]?.account?.contact?.errorFailed);
            return;
        }

        try {
            setLoading(true);
            setError(null);

            await generalRequest.contactSupport(form);

            setSuccess(true);
			setTimeout(() => {
				setSuccess(false);
			}, 5000);
            setForm((prev) => ({
                ...prev,
                subject: "",
                message: "",
                phone: "",
            }));
        } catch (err) {
            setError(err.message || "Failed to send message");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="sf-account-contact-page">
            <h2 className="sf-account-contact-title">{translations[language]?.account?.contact?.title}</h2>

            <form className="sf-account-contact-form" onSubmit={handleSubmit}>
                <input
                    type="email"
                    name="email"
                    placeholder={translations[language]?.account?.contact?.email}
                    value={form.email}
                    onChange={handleChange}
                />

                <input
                    type="text"
                    name="phone"
                    placeholder={translations[language]?.account?.contact?.phone}
                    value={form.phone}
                    onChange={handleChange}
                />

                <input
                    type="text"
                    name="subject"
                    placeholder={translations[language]?.account?.contact?.subject}
                    value={form.subject}
                    onChange={handleChange}
                />

                <textarea
                    name="message"
                    placeholder={translations[language]?.account?.contact?.messagePlaceholder}
                    value={form.message}
                    onChange={handleChange}
                    required
                />

                <button type="submit" disabled={loading}>
                    {loading
                        ? translations[language]?.account?.contact?.sending
                        : translations[language]?.account?.contact?.send}
                </button>

                <BannerMessageFixed
                    type={error ? "error" : success ? "success" : "info"}
                    text={error ? error : success ? translations[language]?.account?.contact?.success : null}
                />
            </form>
        </div>
    );
};

export default AccountContact;
